/**
 * Lazy loader for BeyondIdentity SDK wrapper
 * This ensures the wrapper and SDK are only loaded when passkey functionality is actually needed,
 * preventing unnecessary bundle bloat in the main chunk.
 *
 * Performance: Saves ~8KB (wrapper) + ~6.4MB (SDK) from main bundle
 */

let BeyondIdentityUtilsPromise = null;

/**
 * Dynamically imports and returns the BeyondIdentityUtils wrapper
 * Uses promise caching to prevent multiple imports
 * @returns {Promise<Object>} BeyondIdentityUtils module
 */
export const loadBeyondIdentityUtils = async () => {
    if (BeyondIdentityUtilsPromise) {
        return BeyondIdentityUtilsPromise;
    }

    BeyondIdentityUtilsPromise = import(
        /* webpackChunkName: "beyond-identity-wrapper" */
        './BeyondIdentity'
    )
        .then(module => module.default)
        .catch(err => {
            BeyondIdentityUtilsPromise = null;
            throw err;
        });

    return BeyondIdentityUtilsPromise;
};

export default {
    loadBeyondIdentityUtils
};
